export default __webpack_public_path__ + "72b0981c9888472f6814e452ecadcc33.jpg";